export default {
    name: 'subscription_item_data',
    definition: {},
};
